module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/portal/packages/core-auto-template/src/templates/footer.html -->\n<div class="inner">\n  ';
 if (Netx.cms.portal.attributes.copyright) {
__p+=' \n    <span class="footer-copyright"\n    >\n      '+
((__t=( Netx.cms.portal.attributes.copyright ))==null?'':__t)+
'\n    </span>\n  ';
 } 
__p+='\n</div>\n';
}
return __p;
};
